/**
 * 全局配置文件
 */
export default {
	title: '商城',
	buId: Number(import.meta.env.VITE_BU_ID) || 0,
	key: 'uChoice', //配置主键,目前用于存储
	tokenTime: 28800, //token过期时间(8小时)
	Authorization: 'mallWeb-token',
	lankeyPrefix: 'uChoicePc.', //多语言lankey前缀
	moduleId: '',
	//配置菜单的属性
	menu: {
		iconDefault: '',
		props: {
			label: 'label',
			path: 'path',
			icon: 'icon',
			children: 'children'
		}
	}
}
